//import logo from './logo.svg';
import React from "react";
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import Login from "./auth/Login";
import Admin from "./pages/Admin";
//import Home from "./pages/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "./components/useAuth";

const App = () => {
  //console.log('--App');
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/*" element={<Admin />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
